import type { MyAccountSettingsConfig } from '../../myAccountSettings.types.ts';
import { SUSPENDED_NOTIFICATION_NAMESPACE } from '../../suspendedNotificationNamespaces.ts';
import { ROUTES } from './routes/routes.ts';

const MY_ACCOUNT_SETTINGS: MyAccountSettingsConfig = {
  isFinancialStatementNavShown: true,
  showsProductPreference: false,
  showsAccountReviewReminder: false,
  showsLockedFundsDetailsCta: false,
  isWalletApiLockedFundsEnabled: true,
  showsWrongOtpAsToast: true,
  redirectsToLoginOnCloseAccountUnauthorised: true,
  isLifetimeNetDepositsWithDecimals: true,
  // AU: `SUSPENDED` means KYC verification failed, which a document upload clears —
  // https://lottoland.atlassian.net/wiki/spaces/RPAU/pages/6264193157/Player+Account+Statuses
  // `trackName` matches the checkout CTA's, so both report as one action.
  suspendedAccountCta: {
    textKey: 'upload_document',
    trackName: 'Upload Document',
    testId: 'suspended-notification-button',
  },
  suspendedNotificationNamespaces: {
    default: SUSPENDED_NOTIFICATION_NAMESPACE,
    payments: SUSPENDED_NOTIFICATION_NAMESPACE,
  },
  olderTransactionsContactHref: ROUTES.FOOTER.CONTACT.EMAIL,
};

export { MY_ACCOUNT_SETTINGS };
